import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bubble",
  "use": "bubble-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"bubble\"><path d=\"M256 32c141.385 0 256 93.125 256 208S397.385 448 256 448c-13.578 0-26.905-.867-39.912-2.522C161.099 500.467 95.463 510.328 32 511.776v-13.458c34.268-16.789 64-47.37 64-82.318 0-4.877-.379-9.665-1.082-14.348C37.02 363.52 0 305.275 0 240 0 125.125 114.615 32 256 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bubble.svg
// module id = 7k0e
// module chunks = 1